// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"19be8e4c","594":"19be8e4c","806":"19be8e4c","843":"19be8e4c"}[chunkId] + ".chunk.css";
};